const CognitoConfig = {
  Auth: {
    Cognito: {
      // REQUIRED - Amazon Cognito Identity Pool ID
      identityPoolId: process.env.NEXT_PUBLIC_PROD_COGNITO_IDENTITY_POOL_ID,
      // REQUIRED - Amazon Cognito Region
      region: process.env.NEXT_PUBLIC_PROD_COGNITO_REGION,
      // OPTIONAL - Amazon Cognito User Pool ID
      userPoolId: process.env.NEXT_PUBLIC_PROD_COGNITO_USER_POOL_ID,
      // OPTIONAL - Amazon Cognito Web Client ID
      userPoolClientId:
        process.env.NEXT_PUBLIC_PROD_COGNITO_USER_POOL_WEB_CLIENT_ID,
      signUpVerificationMethod: 'code',
    },
  },
};

// const CognitoConfig = {
//   Auth: {
//     identityPoolId: process.env.NEXT_PUBLIC_PROD_COGNITO_IDENTITY_POOL_ID,
//     region: process.env.NEXT_PUBLIC_PROD_COGNITO_REGION,
//     userPoolId: process.env.NEXT_PUBLIC_PROD_COGNITO_USER_POOL_ID,
//     userPoolWebClientId: process.env.NEXT_PUBLIC_PROD_COGNITO_USER_POOL_WEB_CLIENT_ID,
//     signUpVerificationMethod: 'code',
//   },
// };

export default CognitoConfig;
